import { render } from "./ServicesDetails.vue?vue&type=template&id=2ece3286"
import script from "./ServicesDetails.vue?vue&type=script&lang=js"
export * from "./ServicesDetails.vue?vue&type=script&lang=js"

import "./ServicesDetails.vue?vue&type=style&index=0&id=2ece3286&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__